class ParamsUtil {
  #paramsObj = {};
  get paramsObj() {
    return this.#paramsObj;
  }

  getParamString(key) {
    const param = this.#paramsObj[key];
    if (param === undefined) return "";
    return param.join(",");
  }

  initializeParams() {
    this.#paramsObj = {};
  }

  insertParam(key, value) {
    if (Array.isArray(value)) return false;
    this.#paramsObj[key] = [this.#convertValue(value)];
  }

  updateParam(key, value) {
    if (Array.isArray(value)) return false;
    if (value === "") {
      this.deleteParams(key);
      return true;
    }
    const values = this.#paramsObj[key];
    if (values === undefined) return false;
    const v = this.#convertValue(value);
    if (!(values.indexOf(v) >= 0)) {
      values.push(v);
    }
    this.#paramsObj[key] = values;
    return true;
  }

  upsertParam(key, value) {
    if (Array.isArray(value)) return false;

    const result = this.updateParam(key, value);
    if (result) return true;
    this.insertParam(key, value);

    return true;
  }

  deleteParam(key, value) {
    if (this.#paramsObj[key] === undefined) return;
    const index = this.#paramsObj[key].indexOf(value);
    if (index < 0) return;
    this.#paramsObj[key].splice(index, 1);
  }

  deleteParams(key) {
    delete this.#paramsObj[key];
  }

  deleteInsertParam(key, value) {
    if (Array.isArray(value)) return false;
    this.deleteParams(key);
    if (value === "") return true;
    this.insertParam(key, value);
    return true;
  }

  makeQueryStrings() {
    if (Object.keys(this.#paramsObj).length === 0) {
      return "";
    }

    const params = [];
    const paramsKeys = Object.keys(this.#paramsObj);

    paramsKeys.forEach(async (key) => {
      const value = this.#paramsObj[key].join(",");
      params.push(`${key}=${value}`);
    });

    return params.join("&");
  }

  #convertValue(value) {
    return encodeURIComponent(value);
  }
}
